import React, { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import OpsSidebar from "./OpsSidebar";
import OpsAI from "./OpsAI";

const OpsUIContext = createContext(null);
export const useOpsUI = () => useContext(OpsUIContext);

export default function OpsLayout() {
  const [aiOpen, setAiOpen] = useState(false);
  return (
    <OpsUIContext.Provider value={{ aiOpen, openAI: () => setAiOpen(true), closeAI: () => setAiOpen(false) }}>
      <div className="flex min-h-screen" style={{ background: "#F7F8F6" }}>
        <OpsSidebar />
        <main className="flex-1 min-w-0"><Outlet /></main>
        <OpsAI open={aiOpen} onClose={() => setAiOpen(false)} />
      </div>
    </OpsUIContext.Provider>
  );
}
